import { createAction } from '@reduxjs/toolkit';
import * as containerConstants from './constants';
import type { Product } from '@/lib/types';

export const loadProducts = createAction(containerConstants.LOAD_PRODUCTS);

export const loadProductsSuccess = createAction(
  containerConstants.LOAD_PRODUCTS_SUCCESS,
  (products: any[]) => ({ payload: { products } })
);

export const loadProductsError = createAction(
  containerConstants.LOAD_PRODUCTS_ERROR,
  (error: string) => ({ payload: { error } })
);

export const saveProductRequest = createAction(
  'inventory/SAVE_PRODUCT_REQUEST',
  (product: Product, isNew: boolean) => ({ payload: { product, isNew } })
);

export const adjustStockRequest = createAction(
  'inventory/ADJUST_STOCK_REQUEST',
  (
    productId: string,
    mode: 'add' | 'adjust',
    quantity: number,
    reason: string
  ) => ({ payload: { productId, mode, quantity, reason } })
);

export const deleteProductRequest = createAction(
  'inventory/DELETE_PRODUCT_REQUEST',
  (id: string) => ({ payload: { id } })
);
